import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=3f3bdc34&scoped=true&"
import script from "./Call.vue?vue&type=script&lang=ts&"
export * from "./Call.vue?vue&type=script&lang=ts&"
import style0 from "./Call.vue?vue&type=style&index=0&id=3f3bdc34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3bdc34",
  null
  
)

export default component.exports